import { useEffect, useState } from "react"
import { HasId, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { CARD_NOSE_SHIFT_Y, defaultTimelineDots, ITimelineCard, NOSE_WIDTH } from "src/modules/pe-landing-module/data/interfaces"
import { ICardsProps } from "../../Cards"
import { TimelineDot } from "./TimelineDot"
import { ITimelineDiagramProps } from "./TimelineDiagram"


/* Protopia Ecosystem component */ 
const AMPLITUDE = 116,
    PHASE = Math.PI / 2, 
    LENGTH = .27

const TimeLineDiagramSinusoid = ({...props}: ITimelineDiagramProps): JSX.Element => {
    const sizes             = useScreenSize()
    const data: any = {
        dots: defaultTimelineDots(),
        ...props.data 
    }
    const getAmplitude = (): number => {
        return sizes.width >= WINDOW_WIDTH.TABLET
            ?
            !!data.dots && typeof data.dots?.amplitude !== "undefined" 
                ? 
                data.dots.amplitude 
                : 
                AMPLITUDE 
            :
            0
    }
    const is_two_side       = sizes.width >= WINDOW_WIDTH.TABLET && data.is_two_side 
    const cards: HasId[]    = data.cards as HasId[]
    const perimeter         = data.dots.perimeter || 0
    const amplitude                 = useSyncState<number>( getAmplitude() )
    const shift                     = useSyncState<number>( getAmplitude() + 5 )
    const [length, setLength]       = useState<number>( data.dots?.length || LENGTH )
    const [phase, setOhase]         = useState<number>( !!data.dots && typeof data.dots.phase !== "undefined" ? data.dots.phase : PHASE )
    const pathLength                = useSyncState<number>( 0 )
    const path                      = useSyncState<string>( "" ) 
    
    const lastCard      = document.querySelector(`.landing-card-${cards[cards.length - 1]?.id}`)
    const marginTop     = 0 // CARD_NOSE_SHIFT_Y - perimeter + (data.gap || 0) / 2 + NOSE_WIDTH
    const marginLeft    = sizes.width >= WINDOW_WIDTH.TABLET ? perimeter / 2 + NOSE_WIDTH + 30 : 0
    const h             = pathLength.get() + (data.gap || 0) * cards.length - marginTop - (lastCard?.clientHeight || 0)
    const w             = shift.get() * 2
    const getX = (y:number) : number => {
        return (shift.get() - perimeter * .5 + amplitude.get() * Math.cos( y * Math.PI / 180 * length + phase) )
    }
    
    const sinusoid = ( ) => {
        let _path = ""
        for(var i:number = 0; i < pathLength.get() + perimeter; i++) {  
            const x = shift.get() + amplitude.get() * Math.cos( i * Math.PI / 180 * length + phase )
            _path += i === 0 
                ?
                `M${x} ${i}`
                :
                `L${x} ${i}`
            path.set( _path )
        }
    }

    useEffect(() => {
        amplitude.set(
            sizes.width >= WINDOW_WIDTH.TABLET ? getAmplitude() : 0
        )         
        shift.set(
            sizes.width >= WINDOW_WIDTH.TABLET ? getAmplitude() + 5 + ( data.dots.stroke_width ) : 5
        )         
        const timeout = setTimeout(() => {
            pathLength.set(
                document.querySelector(`.landing-v-timeline-container[data-vertical-timeline-id=${props.timelineId}] `)?.clientHeight || 0
            )
            sinusoid()
            // odd down shift
            if( is_two_side ) {
                const selector = `.landing-v-timeline-cards-${props.section.id} .timeline-shifter`
                const query = document.querySelector(selector)!
                const card0 = document.querySelector(`.landing-card-${cards[0]?.id}`)
                if(query) {
                    query?.setAttribute("style",`height:${ !!card0 ? card0.clientHeight / 2 : "0"}px`)
                } 
            }
        }, 100)
        return () => { 
            clearTimeout(timeout)
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[ data.dots, sizes.width, is_two_side ])

    return <div 
        className={`landing-v-timeline-timiline-container position-relative`} 
        style={{
            marginTop,
            width: w, maxWidth: w,
            marginLeft,
            marginRight: marginLeft
        }} 
    > 
        <svg 
            version="1.1" 
            xmlns="http://www.w3.org/2000/svg" 
            xmlnsXlink="http://www.w3.org/1999/xlink" 
            x="0px" 
            y="0px"
            width={ w }
            height={ h }
            viewBox={`0 0 ${ w } ${ h }`}
            xmlSpace="preserve"
            className=""
            style={{ 
                transform: `translateY(${ perimeter / 2}px)` 
            }}
        >
            <path 
                fill="none" 
                strokeWidth={data.dots?.stroke_width || 1 }
                stroke={ 
                    data.dots?.svg_style?.stroke 
                        ? 
                        data.dots?.svg_style.stroke 
                        : 
                        "var(--force-contast-color)" 
                }
                strokeMiterlimit="10"  
                style={data.dots?.svg_style} 
                d={path.get()}
            />
        </svg>
        {
            Array.isArray(cards) && cards.map((card: any, i: number) =>  { 
                return <TimelineDot
                    key={ card.id }
                    i={i}
                    section={ props.section } 
                    data={data}
                    is_two_side={is_two_side}
                    card={card }
                    shift={shift.get()}
                    amplitude={amplitude.get()}
                    length={length}
                    phase={phase}
                    getX={getX}
                />
            })
        }
    </div>
}
export default TimeLineDiagramSinusoid